export const mockCounty = {
  county_name: 'Fresno',
  county_code: '06019',
  created_at: '2023-06-22T21:37:09.680717',
  updated_at: '2023-06-22T21:37:09.680717',
  state_name: 'California',
  state_code: 'CA',
  zipcode: '93245',
  file_date: '2023-06-22T15:21:20.817030',
  fips_county_code: '06019',
  id: 322722,
  lat: 36.28614,
  lng: -119.83405,
  plan_type_name: [],
  has_plans_in_service: null,
  has_plans: true,
  coverageEffectiveDate: '02-12-2025',
};

export const mockCountyOptions = [
  {
    ...mockCounty,
    value: 'Schenectady',
    data: {
      ...mockCounty,
      has_plans: false,
      zipcodes: [
        {
          lat: 42.8579471,
          lng: -73.9021788,
          code: '12008',
        },
      ],
    },
    label: mockCounty.county_name,
  },
];
